import { setDefaultOptions } from "date-fns";
import { logError } from "../logging";
import type { LocaleInfo } from "./localeCatalog";
import { defaultLocaleInfo, matchSupportedLocale } from "./localeCatalog";

export type { LocaleInfo } from "./localeCatalog";
export { supportedLocales } from "./localeCatalog";

const getSupportedLocaleMatchFromBrowser = (): LocaleInfo => {
  for (const lang of window.navigator.languages ?? []) {
    const matchedLocale = matchSupportedLocale(lang);
    if (matchedLocale) {
      return matchedLocale;
    }
  }

  return defaultLocaleInfo;
};

const localeFromBrowser = getSupportedLocaleMatchFromBrowser();

setDefaultOptions({ locale: localeFromBrowser.locale });

let userLocale = localeFromBrowser;

export const getUserLocaleCode = (): string => userLocale.locale.code;

export const getUserLocaleInfo = (): LocaleInfo => ({ ...userLocale });

export const setUserLocale = (localeCode: string): void => {
  const supportedLocale = matchSupportedLocale(localeCode);
  if (supportedLocale) {
    userLocale = supportedLocale;
    setDefaultOptions({ locale: supportedLocale.locale });
  } else {
    logError(`Unsupported locale code: ${localeCode}`, "[setUserLocale]");
  }
};
